import { EventView } from './types'

const MINUTE_IN_MILLISECONDS = 60 * 1000

let currentEndTime = 0
let timeout: number

export const getNewSessionEndTime = (sessionMinutes: number) => {
    return Date.now() + sessionMinutes * MINUTE_IN_MILLISECONDS
}

// Ensure that view is refreshed when session expires
export const updateSessionExpireTimeout = (view: EventView) => {
    const { sessionEndTime } = view.state

    if (sessionEndTime !== currentEndTime) {
        window.clearTimeout(timeout)
        const remaining = sessionEndTime - Date.now()

        if (remaining) {
            timeout = window.setTimeout(view.update, remaining)
        }

        currentEndTime = sessionEndTime
    }
}
